import { render, staticRenderFns } from "./uploadpic.vue?vue&type=template&id=cbcf797a&scoped=true&"
import script from "./uploadpic.vue?vue&type=script&lang=js&"
export * from "./uploadpic.vue?vue&type=script&lang=js&"
import style0 from "./uploadpic.vue?vue&type=style&index=0&id=cbcf797a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbcf797a",
  null
  
)

export default component.exports